import VueCookies from 'vue-cookies'

export function getUserInfoByCookie () {
  let userId = VueCookies.get('huluer_user_id')
  let jwt = VueCookies.get('huluer_access_token')
  if (userId && Number(userId)) {
    userId = Number(userId)
  } else {
    userId = 0
  }
  if (!jwt) {
    jwt = ''
  }
  return { id: userId, jwt: jwt }
}

export function checkOsType () {
  let osType
  if (/(Android)/i.test(navigator.userAgent)) {
    osType = 'android'
  } else if (/(iPad|iPhone|iPod)/i.test(navigator.userAgent)) {
    osType = 'ios'
  } else if (/(Windows)/i.test(navigator.userAgent)) {
    osType = 'windows'
  } else if (/(Mac OS)/i.test(navigator.userAgent)) {
    osType = 'mac'
  } else if (/(Linux)/i.test(navigator.userAgent)) {
    osType = 'linux'
  } else {
    osType = 'other'
  }
  return osType
}

export function checkBrowserType () {
  let browserType
  if (/(MicroMessenger)/i.test(navigator.userAgent)) {
    browserType = 'weixin'
  } else if (/(Opera)/i.test(navigator.userAgent)) {
    browserType = 'opera'
  } else if (/(Firefox)/i.test(navigator.userAgent)) {
    browserType = 'firefox'
  } else if (/(Chrome)/i.test(navigator.userAgent)) {
    browserType = 'chrome'
  } else if (/(Safari)/i.test(navigator.userAgent)) {
    browserType = 'safari'
  } else if (/(MSIE)/i.test(navigator.userAgent)) {
    browserType = 'ie'
  } else {
    browserType = 'other'
  }
  return browserType
}
